export type ApiVersion = 'v1' | 'v2'

function normalizePrefix(prefix: string): string {
  if (prefix === '') return ''
  const withSlash = prefix.startsWith('/') ? prefix : `/${prefix}`
  return withSlash.endsWith('/') ? withSlash.slice(0, -1) : withSlash
}

function envString(key: string): string | undefined {
  const v = import.meta.env[key] as string | undefined
  return typeof v === 'string' && v.length > 0 ? v : undefined
}

export function apiPrefix(version: ApiVersion = 'v1'): string {
  if (version === 'v2') {
    return normalizePrefix(envString('VITE_API_V2_PREFIX') ?? '/api/v2')
  }
  return normalizePrefix(envString('VITE_API_PREFIX') ?? '/api/v1')
}

export function apiPath(path: string, version: ApiVersion = 'v1'): string {
  const clean = path.startsWith('/') ? path : `/${path}`
  return `${apiPrefix(version)}${clean}`
}

export const apiV1 = (path: string) => apiPath(path, 'v1')
export const apiV2 = (path: string) => apiPath(path, 'v2')

